<template>
  <div class="relative flex flex-col section-template w-full h-90vh z-20 justify-center pointer-events-none">
    <div class="flex flex-col justify-center items-start w-full sm:w-1/2 flex-1 text-left text-blue-900 px-3 mx-auto">
      <h2
        class="anim-item text-xl xs:text-2xl md:text-4xl font-bold mb-4 sm:mb-8 leading-tight text-white"
        v-html="$t(`sections.${content.id}.title`)"
      ></h2>
      <p
        class="anim-item max-w-2xl text-tiny xs:text-sm sm:text-base md:text-lg text-white"
        v-html="$t(`sections.${content.id}.text`)"
      ></p>
      <router-link class="mt-12" :to="$t(`sections.${content.id}.link`)">
        <button class="flex bg-black rounded-full text-white px-4 py-2 font-bold pointer-events-auto button-style">
          <section-redirect-icon class="mr-4" /><span>{{ $t(`sections.${content.id}.buttonText`) }}</span>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SectionRedirectIcon from "./SectionRedirectIcon";

export default {
  name: "SectionTextRedirect",
  components: {
    SectionRedirectIcon,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    nextSection: {
      type: String,
      required: false,
    },
    animated: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollToPlugin);
    gsap.registerPlugin(ScrollTrigger);
    this.animated && this.setScrollAnimation();
  },
  methods: {
    setScrollAnimation() {
      const sectionId = `#${this.content.id}`;

      gsap.from(sectionId, {
        scrollTrigger: { trigger: sectionId, toggleActions: "play pause resume reset" },
        duration: 2,
        opacity: 0,
        y: 200,
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
p a {
  @apply underline;
}

.h-90vh {
  height: 90vh;
}

@media screen and (max-height: 599px) {
  h2 {
    @apply text-xl mb-4;
  }
  p {
    @apply leading-tight text-tiny;
  }
  .scroll-button {
    @apply hidden;
  }
}

@media screen and (min-height: 600px) and (max-height: 812px) and (max-width: 420px) {
  .scroll-button {
    display: flex;
    bottom: 3vh;
  }
}
</style>